<template>
  <div class="income w-100-pct h-100-pct">
    <div class="vert w-100-pct h-100-pct bg-wt al-it-c">
      <div class="wid-dyn">
        <navbar v-bind:selindex=2></navbar>
      </div>
      <div class="vert h-100-pct just-start wid-dyn p-x-1v bg-p1 m-b-16">
        <input class="m-t-1v input box w-100-pct inset1" v-model="currentFmt" readonly>
        <div class="row">
          <button type="button" class="button memory" v-on:click="memClear">MC</button>
          <button type="button" class="button memory" v-on:click="memSave">MS</button>
          <button type="button" class="button memory" v-on:click="memAdd">M+</button>
          <button type="button" class="button memory" v-on:click="memRecall">MR</button>
        </div>
        <div class="row">
            <button type="button" class="button bg-wt-h" v-on:click="clear"><div>C</div></button>
            <button type="button" class="button bg-wt-h" v-on:click="backspace">
              <img class="m-t-1v h-2-rem" svg-inline src="@/assets/delete.svg"/>
            </button>
            <button type="button" class="button bg-wt-h" v-on:click="exponent">x^y</button>
            <button type="button" class="button bg-wt-h" v-on:click="press">%</button>
        </div>
        <div class="row">
            <button type="button" class="button bg-wt-h" v-on:click="press">(</button>
            <button type="button" class="button bg-wt-h" v-on:click="press">)</button>
            <button type="button" class="button bg-wt-h" v-on:click="plusMinus"> +/- </button>
            <button type="button" class="button bg-wt-h" v-on:click="invert">1/x</button>
        </div>
        <div class="row">
            <button type="button" class="button primary" v-on:click="press">7</button>
            <button type="button" class="button primary" v-on:click="press">8</button>
            <button type="button" class="button primary" v-on:click="press">9</button>
            <button type="button" class="button bg-wt-h" v-on:click="multiply">*</button>

        </div>
        <div class="row">
            <button type="button" class="button primary" v-on:click="press">4</button>
            <button type="button" class="button primary" v-on:click="press">5</button>
            <button type="button" class="button primary" v-on:click="press">6</button>
            <button type="button" class="button bg-wt-h" v-on:click="press">/</button>


        </div>
        <div class="row">
            <button type="button" class="button primary" v-on:click="press">1</button>
            <button type="button" class="button primary" v-on:click="press">2</button>
            <button type="button" class="button primary" v-on:click="press">3</button>
            <button type="button" class="button bg-wt-h" v-on:click="press">+</button>

        </div>
        <div class="row">
            <button type="button" class="button primary" v-on:click="press">.</button>
            <button type="button" class="button primary" v-on:click="press">0</button>
            <button type="submit" class="button primary" v-on:click="press">=</button>
            <button type="button" class="button bg-wt-h" v-on:click="press">-</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navbar from './navbar.vue'
export default {
  name: 'calculator',
  data () {
    return {
      current: '',
      currentFmt: '',
      changeMode: true,
      memory: 0,
      isResult: false,
    }
  },
  components: {
    navbar
  },

  mounted () {
    const _this = this
    window.addEventListener("keypress", function(e) {
      if (e.keyCode === 13) {
        e.preventDefault()
        _this.keypress('=')
      } else {
        _this.keypress(String.fromCharCode(e.keyCode))
      }
    })
    window.addEventListener("keydown", function(e) {
      if (e.keyCode === 8) {
        _this.backspace()
      }
    })

  },
  watch: {
    current: function (newValue) {
      this.currentFmt = this.formatNumber(newValue.toString())
    }
  },
  methods : {
    press: function (event) {
      let key = event.target.innerText;
      this.keypress(key)
    },

    formatNumber (newValue) {
      return newValue.replace(/,/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    keypress: function (key) {
      if ( ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '(', ')', '.'].includes(key)) {
        if (this.isResult) { this.current = '';}
        this.current += key;
        this.isResult = false
      } else if ( ['+', '*', '-', '^'].includes(key)) {
        this.current += key;
        this.isResult = false
      } else if ( key === "=") {
        this.equals();
      } else if ((key === "C") || (key === "c")) {
        this.clear();
      } else if (key === "*") {
        this.multiply();
      } else if (key === "/") {
        this.divide();
      } else if (key === "�") {
        this.plusMinus();
      } else if (key === "%") {
        this.percent();
      }

    },

    equals () {
      if ((this.current).indexOf("^") > -1) {
        var base = (this.current).slice(0, (this.current).indexOf("^"));
        var exponent = (this.current).slice((this.current).indexOf("^") + 1);
        this.current = eval("Math.pow(" + base + "," + exponent + ")").toString();
      } else {
        this.current = eval(this.current).toString()
      }
      this.isResult = true
    },

    memAdd () {
      this.memory = this.memory + eval(this.current)
    },

    memRecall () {
      this.current = this.memory
    },

    memSave () {
      this.memory = eval(this.current)
    },

    memClear () {
      this.memory = 0
    },


    clear () {
      this.current = "";
      this.isResult = false
    },

    backspace () {
      if (this.isResult) {
        this.current = ''
      } else {
        this.current = this.current.substring(0, this.current.length - 1);
      }
      this.isResult = false
    },

    multiply  () {
      this.current += "*";
      this.isResult = false
    },

    divide () {
      this.current +=  "/";
      this.isResult = false
    },

    plusMinus () {
      if (this.current.charAt(0) === "-") {
        this.current = this.current.slice(1);
      } else {
        this.current = "-" + this.current;
      }
      this.isResult = false
    },

    invert () {
      this.current = eval(this.current)
      this.current = (1/this.current).toString()
      this.isResult = true
    },

    percent () {
      this.current = this.current / 100;
      this.isResult = true
    },

    exponent () {
      this.current += "^";
      this.isResult = false;
    },
  }


}
</script>

<style scoped>
  .row {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .input {
    /* width: 262px;
    max-width: 262px;
    min-width: 262px; */
    /* height: 50px; */
    height: 8vh;
    border-radius: 4px;
    border: 1px solid #ced4da;
    background-color: #ffffe0;
    color: #000000;
    font-size: 6vh;
    text-align: left;
    padding-left: 1vmin;
    padding-right: 1vmin;
  }

  .button {
    margin-top: 1vmin;
    margin-left: 0.5vmin;
    margin-right: 0.5vmin;
    border: 1px solid #ced4da;
    /* width: min(23vw, 12vh); */
    width: min(23vw, 12vh);
    height: min(23vw, 11vh);
    border-radius: 4px;
    color: #000000;
    cursor: default;
    outline: none;
    font-size: min(8vw, 4vh);
    box-shadow: var(--button-shadow);
  }

  .primary {
    background-color: #cad8fa;
  }

  .memory {
    background-color: #d0c0ea;
    height: 7vh;
  }

  .basic-mode {
    width: 278px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    margin: auto;
  }

  .equal-sign {
    background-color: #f7f8f9;
    width: 133px;
  }

  .toggle-button {
    border: none;
    background-color: #e9ecef;
    cursor: pointer;
    outline: none;
  }

  button::-moz-focus-inner {
    border-color: transparent;
  }
  .lightbox {
    padding: 12px 0 2px 0;
  }


</style>
